module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "delete"
  }, [_c('div', {
    staticClass: "signup__container"
  }, [_c('div', {
    staticClass: "step__container"
  }, [_c('div', {
    ref: "button",
    staticClass: "step__button"
  }, [_c('a', {
    class: {
      'button button--full': true
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.buttonClicked($event)
      }
    }
  }, [_c('span', {
    staticClass: "button__title"
  }, [_vm._v("Test button")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e67b8e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/3-pages/Test.vue
// module id = 536
// module chunks = 1